import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FiX } from 'react-icons/fi';
import { Button } from 'components';

const Card = ({ title, closeButton, bottomContent, className, children, closeHandler, daySaveHandler }) => {
  return (
    <div className={cx('card clearfix', className)}>
      {title && (
        <div className="card_header clearfix">
          <div className="form-section-header float-left"> {title} </div>
          {closeButton && (
            <FiX size={24} color="#6C757D" className="icon float-right card-close-margin" onClick={closeHandler} />
          )}
        </div>
      )}
      <div className="card-body clearfix">
        {children}
        {/* <FiPlusCircle size={24} color="#007BFF" onClick={addHandler} className="icon float-right align-center" /> */}
      </div>
      {bottomContent && <div className="card_bottom"> {bottomContent} </div>}
      <div className="card-footer d-flex float-right">
        <Button secondary clickHandler={closeHandler} className="mr-8">
          Close
        </Button>
        <Button primary clickHandler={daySaveHandler}>
          Save
        </Button>
      </div>
    </div>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  closeButton: PropTypes.bool,
  closeHandler: PropTypes.func,
  children: PropTypes.any,
  bottomContent: PropTypes.any,
  daySaveHandler: PropTypes.func,
};

Card.defaultProps = {
  className: '',
  closeButton: false,
  closeHandler: () => {},
};

export default Card;
